export const locale = {
  lang: 'en',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'INST_1':'Download the question template',
        'INST_2':'Make the necessary changes to the template',
        'INST_3':'Load the question template',
        'BTN_DESC_PLAN':'Question Template',
        'BUSC_PLAN_TEX':'Click here to search for the template questions',
        'TEMP_CARG_TIT':'Template information',
        'TOT_PREG':'Total questions',
        'TOT_PREG_MODI':'Total modified questions',
        'TOT_PREG_NUE':'Total new questions',
        'TEMP_CARG_TIT_CAR':'Template information loaded',
        'COMPL_PAS_SIN_MODI':'You have not made any modification yet. You are sure to complete the step?',
        'SUCC_CAR_PLAN':'The template was successfully loaded. Please complete the step',
        'COMPLE_PASO_CON_MODI':'Are you sure to complete the step with the currently entered changes?',
        'NO_MODIF':'Do not modify this cell content',
        'ERROR_CARGA': 'The file cannot be loaded, modifications were detected in one or more restricted cells, redownload the template and make the desired modifications without modifying the restricted cells. \n\nThe restricted cells contain a comment indicating that their content should not be modified',
        'FORALL_EXCEDIDAS': 'It was detected that the number of 4All practices present in the loaded template exceeds the number of allowed practices, only the practices that correspond to the maximum allowed were loaded',
        'OPCIONDEMOGRAFICOS': 'This cell must contain an unchanged value from the demographic catalog sheet',
        'CARGANDO_PREGUNTAS': 'Loading questions from the template'
      },
      'CATALOGO_IDIOMAS':{
        'z1': 'Simplified Chinese',
        'z2': 'Traditional Chinese',
        'ko': 'Korean',
        'ja': 'Japanese',
        'pt': 'Portuguese',
        'en': 'English',
        'fr': 'French',
        'de': 'German',
        'it': 'Italian',
        'es': 'Spanish',
        'tr': 'Turkish',
        'ms': 'Malay',
        'ro': 'Romanian',
        'vi': 'Vietnamese',
        'bg': 'Bulgarian',
        'hi': 'Hindi',
        'ru': 'Russian',
        'mn': 'Mongolian',
        'nl': 'Dutch',
        'ar': 'Arab',
        'ua': 'Ukrainian',
        'id': 'Indonesian',
      },
      'HOJAS_EXCEL':{
       'Instrucciones': 'Instructions',
       'Catalogo':'Catalog',
       'Detalles': 'Details',
       'CatDemograficos': 'Demographic Catalog',
       'Nps':'Nps',
       'Reactivos':'Statements',
       'Control':'Control',
       'Demograficos':'Demographics',
       'Abiertas':'Open',
       'Forall':'Forall',
       'Adicionales':'Additional',
     },
     'COLUMNAS_H_CATA':{
       'ClaveIdiomas':'LanguageKey',
       'NombreIdiomas':'LanguageName',
       'IDTipoPregunta': 'Question type ID',
       'TiposPreguntas': 'Question types',
       'ClaveTipoElemento': 'Element type key',
       'TiposElementos': 'Element types',
       'CONTEM_TIP_PREG':{
         '1': 'NPS / Control / Additional question (multiple choice, one answer)',
         '2_1':'NPS / Control / open-ended question, open text type',
         '2_2':'NPS / Control / open-ended question, numerical text type',
         '3':'Reactive type question',
         '4':'Demographic type question (multiple choice, one answer)',
         '5':'Practice 4All',
         '6':'Additional question (multiple choice, multiple answers)',
       },
       'CONTEM_TIP_SEGM':{
         'question': 'Question text',
         'answer_1': 'Text of answer 1',
         'answer_2': 'Text of answer 2',
         'answer_n': 'Text of answer n',
         'practice': 'Text of practice 4All',
         'description': 'Text of description of practice 4All',
         'statement_1': 'Question 1 of practice 4All',
         'statement_2': 'Question 2 of practice 4All',
       }
     },
     'COLUMNAS_SECCION':{
      'Id':	'Id',
      'TipoDePregunta':	'QuestionType',
      'PalabrasClave':	'KeyWords',
      'NuevaPregunta':	'NewQuestion',
      'Eliminable':	'Eliminable',
      'Editable':	'Editable',
      'RespuestaObligatoria':	'CompulsoryAnswer',
      'MostrarPregunta':	'ShowQuestion',
      'Dimension':	'Dimension',
      'Competencia':	'Competence',
      'Subcompetencia':	'Subcompetence',
      'TipoDemografico':	'TypeDemographic',
      'practice':	'practice',
      'description':	'description',
      'statement_1':	'statement_1',
      'statement_2':	'statement_2',
      'question':	'question',
      'answer':	'answer',
      'OpcionOtro': 'Answer type "Other"'

     }
    }
  }
};
